import React from 'react';
import PropTypes from 'prop-types';

import LocalizationConsumer from '../../../l10n/localization-context';

import './insert-link-to-anchor.less';

const InsertLinkToAnchor = ({
  anchorName,
  linkText,
  tooltip,
  isLinkEditable,
  isLinkHidden,
  previewImage,
  onChange
}) => (
  <div className="insertLinkToAnchorContainer">
    <table className="formStructureTable">
      <tbody>
        <tr>
          <td valign="top" className="propertiesListContainer">
            <table cellSpacing="0" cellPadding="0">
              <tbody>
                <tr>
                  <th>
                    <LocalizationConsumer id="insert-link-to-anchor-dialog.anchor-label" />
                  </th>
                  <td>
                    <input
                      type="text"
                      maxLength="1024"
                      value={anchorName}
                      onChange={e => onChange('anchorName', e.target.value)}
                    />
                    <div className="inputTooltip">
                      <LocalizationConsumer id="insert-link-to-anchor-dialog.anchor-tooltip" />
                    </div>
                  </td>
                </tr>

                { !isLinkHidden ? (
                <tr>
                  <th>
                    <LocalizationConsumer id="insert-link-to-anchor-dialog.link-label" />
                  </th>
                  <td>
                    { isLinkEditable ?
                      <input
                        type="text"
                        maxLength="1024"
                        value={linkText}
                        onChange={e => onChange('linkText', e.target.value)}
                      /> :
                      <div className="unchangeableTitle" id="idInputLinkToAnchorUnchangeableTitle">{linkText}</div>
                    }
                  </td>
                </tr>)
                  : null }
                { previewImage ? (
                  <tr className="tagLinkImagePreview">
                    <th>
                      <LocalizationConsumer id="insert-link-to-anchor-dialog.image-preview-label" />
                    </th>
                    <td>
                      <div className="imageContainer">
                        <img className="inputLinkToAnchorImage" src={previewImage} alt="" />
                      </div>
                    </td>
                  </tr>)
                  : null }
                <tr>
                  <th>
                    <LocalizationConsumer id="insert-link-to-anchor-dialog.tooltip-label" />
                  </th>
                  <td>
                    <input
                      type="text"
                      maxLength="1024"
                      value={tooltip}
                      onChange={e => onChange('tooltip', e.target.value)}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

InsertLinkToAnchor.propTypes =
{
  anchorName: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  isLinkEditable: PropTypes.bool.isRequired,
  previewImage: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default InsertLinkToAnchor;